import { API_BASE_URL as API_BASE } from './apiConfig';

export const getFriendShoringMatrix = async ({ asOf, mineral, version, includeInputs = false } = {}) => {
  try {
    const params = new URLSearchParams();
    if (asOf) params.set("as_of", asOf);
    if (mineral) params.set("mineral", mineral);
    if (version) params.set("version", String(version));
    if (includeInputs) params.set("include_inputs", "true");

    const qs = params.toString();
    const res = await fetch(`${API_BASE}/api/friend-shoring-matrix${qs ? `?${qs}` : ""}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (err) {
    console.error("Fetch friend-shoring matrix failed:", err);
    return { success: false, data: [], error: err.message };
  }
};

export const getCountryIntelligence = async (countryIso3, { asOf, mineral, minimal = true } = {}) => {
  try {
    const params = new URLSearchParams();
    if (asOf) params.set("as_of", asOf);
    if (mineral) params.set("mineral", mineral);
    if (minimal) params.set("minimal", "true");
    const qs = params.toString();

    const res = await fetch(`${API_BASE}/api/country-intelligence/${encodeURIComponent(countryIso3)}${qs ? `?${qs}` : ""}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (err) {
    console.error("Fetch country intelligence failed:", err);
    return { success: false, data: null, error: err.message };
  }
};

